import React from 'react';
import { getGreeting } from '../utils/greetings';

function AppShell({ employee, onHistory, onLogout, onBackHome, children }) {
  return (
    <div className="app-container">
      <header className="app-header">
        <div className="user-info">
          <div className="header-left">
            <img src="/logo.png" alt="FSI Logo" className="header-logo" />
            <span className="user-name">{getGreeting(employee?.name || '')}</span>
          </div>
          <div className="header-actions">
            {onHistory ? (
              <button onClick={onHistory} className="btn-history">Lịch sử</button>
            ) : null}
            {onBackHome ? (
              <button onClick={onBackHome} className="btn-back-home">Về trang chủ</button>
            ) : null}
            <button onClick={onLogout} className="btn-logout">Đăng xuất</button>
          </div>
        </div>
      </header>
      {children}
    </div>
  );
}

export default AppShell;
